import { Dropdown } from "primereact/dropdown";
import { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "./index";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";

let reg = new RegExp(/(.*)\[(.*)\]/);
export const ChoiceInput = ({
  value,
  defaultValue,
  onChange,
  placeholder,
  type,
  disabled
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const [incorrectDefaultValue, setIncorrectDefaultValue] =
    useState<boolean>(false);

  const verifyType = (value: any) => {
    return typeof value === "string";
  };

  const [valueWidget, setValueWidget] = useState(() => {
    if (value) return value;
    if (defaultValue) {
      if (verifyType(defaultValue)) return defaultValue;
      else setIncorrectDefaultValue(true);
    }
    return undefined;
  });

  const [args] = useState<{ label: string; value: string }[] | undefined>(
    () => {
      let m = type.match(reg);
      if (m) {
        if (m.length > 1) {
          let tmp = m[2].split(";").map((c) => {
            return { label: c, value: c };
          });
          return tmp;
        }
        return undefined;
      }
      return undefined;
    }
  );

  return (
    <div>
      <ErrorDefaultValueWidget
        displayError={incorrectDefaultValue}
      ></ErrorDefaultValueWidget>
      <Dropdown
        value={valueWidget}
        options={args}
        onChange={(e) => {
          setValueWidget(e.value);
          onChange(e.value);
          setIncorrectDefaultValue(false);
        }}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};
